export function mediana(valores) {
    if (!valores.length) return 0;

    const ordenados = [...valores].sort((a, b) => a - b);
    const meio = Math.floor(ordenados.length / 2);
    // quantidade ímpar
    if (ordenados.length % 2 !== 0) return ordenados[meio];

    // quantidade par
    return (ordenados[meio - 1] + ordenados[meio]) / 2;
}

export function variacao(anterior, atual) {
    return atual > 0 ? 1 - anterior / atual : "Indefinida";
}

export function media(valores) {
    if (!valores.length) return 0;
    return valores.reduce((soma, valor) => soma + valor, 0) / valores.length;
}

export function coeficienteVariacao(valores) {
    if (!valores.length) return 0;

    const mediaCalculada = media(valores);
    const desvio = desvioPadrao(valores);

    return mediaCalculada !== 0 ? desvio / mediaCalculada : 0;
}

export function desvioPadrao(valores) {
    if (!valores.length) return 0;

    const mediaCalculada = media(valores);

    const variancia =
        valores.reduce((soma, valor) => {
            const diferenca = valor - mediaCalculada;
            return soma + diferenca * diferenca;
        }, 0) / valores.length;

    return Math.sqrt(variancia);
}

export function calcularProjecaoCusto(media, valor) {
    const valorNumerico = parseFloat(valor || 0);
    return valorNumerico + Math.abs(valorNumerico) * parseFloat(media || 0);
}

export function calcularDesvioPadraoNegativoCusto(desvioPadrao, valor) {
    return parseFloat(valor || 0) * (1 - parseFloat(desvioPadrao || 0));
}

export function calcularDesvioPadraoPositivoCusto(desvioPadrao, valor) {
    return parseFloat(valor || 0) * (1 + parseFloat(desvioPadrao || 0));
}
